// This file provides process.env as a module for @01/config and other utilities
// For browser environments, we export import.meta.env instead of Node's process.env
export default import.meta.env
